var engraving_free = 42024316207361;
var chrome = false;

var engraving_cost = 42024316141825;
var engraving_cost_under = 9900;

var mce_form = "";
var logged = false;

var isMobile = false; //initiate as false

var webserviceUrl = 'https://ws.penoblo.com/gui-backend';

var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


window.addEventListener('cartloaded', function(){
  $('.Cart__ShippingNotice .Drawer__Container').html( $('.hiddenFreeDelivery').html() );
})

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function hideCart(){
    $('.PageOverlay').removeClass('is-visible');
    $('body').removeClass('no-scroll');
    $('#sidebar-cart').attr('aria-hidden', true );    
  }
  function showCart(){
    $('.PageOverlay').addClass('is-visible');
    $('body').addClass('no-scroll');
    $('#sidebar-cart').attr('aria-hidden', false );
    
    $('.PageOverlay' ).on('click', hideCart );
    $('.Drawer__Close[data-drawer-id=sidebar-cart]' ).on('click', hideCart );
  }


function refreshCart( warenkorbOnly ){
  
  
  var warenkorbOnly = warenkorbOnly != undefined ? true : false;
  
  
  
  
   var cartRefreshUrl = '/cart?view=drawer&timestamp='+Date.now();
  
  
  	$.ajax({
        type: 'GET',
        url: cartRefreshUrl,        
        async:false,
      	success: function( data ) {
     
         
         var fullSide = $( data );           
         var mainContent = fullSide.find('.Cart.Drawer__Content');


         var inner = mainContent.html();
           
           
         window.setTimeout( function(){ $('.Cart.Drawer__Content').html( inner ) }, 1500 );       


         var settings = jQuery.parseJSON( fullSide.attr('data-section-settings') );
         $('.Header__CartCount').html( settings.itemCount );

         
         if ( settings.itemCount == 0 ){
           $('.Header__CartDot').removeClass('is-visible');
         } else {
           $('.Header__CartDot').addClass('is-visible');
         }
           

         $('.engraving-popup').hide();


   		}
    });
 }


if ( $('.FallBack_Content').length > 0 ){
  $('.FallBack_Content h1').addClass('SectionHeader__Heading Heading u-h1');
  $('.FallBack_Content h2').addClass('SectionHeader__Heading Heading u-h2');
  $('.FallBack_Content h3').addClass('SectionHeader__Heading Heading u-h3');
  $('.FallBack_Content h4').addClass('SectionHeader__Heading Heading u-h4');
  $('.FallBack_Content h5').addClass('SectionHeader__Heading Heading u-h5');
  $('.FallBack_Content h6').addClass('SectionHeader__Heading Heading u-h6');
}

/* EXIT INTEND POPUP */

var ei_startuptime = new Date().getTime();
var ei_windowHeight = $(window).height();
var ei_windowWidth = $(window).width();
var ei_offsetbind = false;
var ei_howmanytimes = 0;
var ei_lasttime = 0;
var ei_chromealert = true;
var ei_lastx, lasty = 0;


var ei_attributes = {};
var ei_template = '';

var ei_show_onleave = false;
var ei_show_basket = false;
var ei_show_inactive = false;

var ei_idletime = 0;
var ei_action = 'leave';

/* CONFIG  */

// Verzögerung nach verlassen des viewPort
var ei_delay = 250;

// wann soll das ei popup angezeigt werden
var ei_trigger =['top'];

// über cookie speichern ob der event ausgelösst wurde
var ei_cookie = true;

// wie oft soll das ei angezeigt werden?
var ei_maxamount = 1;   
var ei_1 = ei_2 = ei_3 = 0;

// soll der Cookie für die maximale anzeige beim neuladen der Seite zurückgesetzt werden?
var ei_reset_cookie = true;

var exit_intend_cookie_name = 'PEICS';

// minimale Zeit zum anzeigen nach dem laden der Seite
var ei_mintime = 0;      

// in welchen abständen soll das popup maximal erscheinen ?
var ei_interval = 2000;


function chromefix(){
  ei_offsetbind = false;
  $(document).bind('mousemove.bindoffset',function(e)
                   {
    if (ei_offsetbind)
    {
      $(document).bind('mouseleave', function(e) { setTimeout(function(){ontheleave(e);}, ($('.EiPopup.PopupLeave').data('section-delay')*1000) ); });
      $(document).unbind("mousemove.bindoffset");
    }
    ei_offsetbind = true;
  });
}

function getamount(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i=0; i<ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1);
            if (c.indexOf(name) != -1) return c.substring(name.length,c.length);
        }
        return 0;
    }


function ontheleave(e)
{
  
  
  var scrolltop = document.documentElement ? document.documentElement.scrollTop : document.body.scrollTop;
  var scrollleft = document.documentElement ? document.documentElement.scrollLeft : document.body.scrollLeft;
  scrolltop = ($(document).scrollTop() > scrolltop) ? $(document).scrollTop() : scrolltop;
  scrollleft = ($(document).scrollLeft() > scrollleft) ? $(document).scrollLeft() : scrollleft;

  if ((Math.round(e.pageX) == -1 || Math.round(e.pageY) == -1) || (e.pageX == -3 || e.pageY == -3))
  {
    var clienty = -ei_lasty + scrolltop;
    var clientx = ei_lastx - scrollleft;
  } else {
    var clienty = -e.pageY + scrolltop;
    var clientx = e.pageX - scrollleft;
  }

  var ey1 = (-ei_windowHeight / ei_windowWidth) * clientx;
  var ey2 = ((ei_windowHeight / ei_windowWidth) * clientx) - ei_windowHeight;

  var leaveside;
  if (clienty >= ey1)
  {
    if (clienty >= ey2)
    {
      leaveside = "top";

    } else {
      leaveside = "right";
    }
  } else {
    if (clienty >= ey2)
    {
      leaveside = "left";
    } else {
      leaveside = "bottom";
    }
  }

  if (/Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent)){
    if (clienty < 0 && clienty > -ei_windowHeight && clientx > 0 && clientx < ei_windowWidth){
      return;
    }
  }

  
  if ($.inArray(leaveside, ei_trigger) != -1 || $.inArray('all', ei_trigger) != -1)
  {
    showEi( 'leave' );     
  }

  if (chrome){
    $(document).unbind("mouseleave");
    chromefix();
  }

}

function ontheleaveMobile(){

  var sh = true;
  var wp1 = 0;
  var wp2 = 0;
  var enableBackScrollCheck = false;
  var viewport50 = window.screen.height;

  $(window).scroll(function (event) {

    var scroll = $(window).scrollTop()+window.screen.height;
    if ( !sh ) return;
    var wh50 = parseInt($('body').height()/2);

    if ( scroll > wp1 ){ dir = 'down'; } else { dir = 'up';	}
    wp1 = scroll;
    if ( dir == 'down' ){
      // wenn wir runtercrollen nichts checken - aber die position festhalten
      enableBackScrollCheck = false;				
      wp2 = wp1;

    } else if ( dir == 'up' && scroll > wh50) {
      // wenn wir hochscrollen und schon mehr als 50% der seite gesehen haben dann check einschalten

      if ( !enableBackScrollCheck ){					
        enableBackScrollCheck = true;
      }
    }

    // is der check aktiv
    if ( enableBackScrollCheck ){
      if ( wp2-viewport50 > wp1 ){
        if ( sh){
          sh = false;
          showEi( 'leave' );   
        }

      }
    }


  });
}

var tabi =  $('#sidebar-cart').attr('tabindex');

function addMailChimp( formclass ){
  
  $('.mc-form').children().remove();
  
  var newsletter_show = $('.EiPopup'+formclass).data('newsletter-show');  
  if ( newsletter_show == false ) return;
  
  
  
  var newsletter_fields = $('.EiPopup'+formclass).data('newsletter-fields');
  
  
  mce_form = mce_form.replace('#1#','<a href="https://weidlor-shop.shop/pages/datenschutzerklarung" target="_blank" class="linki">');
  mce_form = mce_form.replace('#2#','</a>');
  mce_form = mce_form.replace(/#br#/g,'<br>');
    
  $('.EiPopup'+formclass+' .mc-form').html( mce_form );
  
  
  
  if ( newsletter_fields == 1 ){
    $('#mce-FNAME').remove();
    $('#mce-LNAME').remove();  
    $('.mc-2columns').remove();
  }
  
   if ( newsletter_fields == 2 ){    
    $('#mce-LNAME').remove();  
    $('.mc-2columns').removeClass('.mc-2columns');
   }
  
   if ( newsletter_fields == 3 ){    
    $('#mce-FNAME').remove();    
    $('.mc-2columns').removeClass('.mc-2columns');
   }
  
  
   if ( newsletter_fields != 5 ){    
    $('#MMERGE4div').remove();    
   }
  
  
  
  var observer1 = new MutationObserver( function( mutations ){
    mutations.forEach(function(mutation) {
      
      var elem = $(mutation.target);   
      if ( elem.html().includes("hank you") )
        $('#mce-success-response').html( $('#mc_embed_signup-default').data('msg-send') );
      
        $('#mc-embedded-subscribe-form input').remove();
      	$('#MMERGE4div').remove();
        $('#mc-embedded-subscribe-form button').remove();
      
      
  	});
  });
  
  var observer2 = new MutationObserver( function( mutations ){
    mutations.forEach(function(mutation) {
      
      var elem = $(mutation.target);      
      if ( elem.html().includes("already subscribed") || elem.html().includes("has too many") )
        $('#mce-error-response').html( $('#mc_embed_signup-default').data('msg-allready') );
      
      
  	});
  });
  
  var config = { characterData: false, attributes: false, childList: true, subtree: false };
  observer1.observe( document.querySelector('#mce-success-response'), config);  
  observer2.observe( document.querySelector('#mce-error-response'), config);
  
  $('#mc-embedded-subscribe-form').on('submit', function(){
    
   		
    
     setTimeout(function(){
       
       	if ( $('.mce_inline_error').length > 0 ){
     	 	$('#mce-error-response').html( $('#mc_embed_signup-default').data('msg-error') );
      		$('#mce-error-response').show();
        } else {
        
          // wenn onleave und email eingetragen dann cookie setzen
          if ( formclass == '.PopupLeave' ) setCookie( exit_intend_cookie_name, 66 , 365 );
          
        }
        
       
     }  , 500 );
    
  });
  
  /*$('#mce-success-response').html( $('#mc_embed_signup-default').data('msg-send') );
  $('#mce-error-response').html( $('#mc_embed_signup-default').data('msg-allready') );*/
  
  
    
  $.getScript( "//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js", function( data, textStatus, jqxhr ) {
    
    window.fnames = new Array();
    window.ftypes = new Array();
    fnames[0]='EMAIL';
    ftypes[0]='email';
    
    fnames[1]='FNAME';
    ftypes[1]='text';
    
    fnames[2]='LNAME';
    ftypes[2]='text';
    
    fnames[3]='DSCNT_CODE';
    ftypes[3]='text';
    var $mcj = jQuery.noConflict(true);
    
  });

  
}

function closeEi(){
   $('.EiPopup').attr('aria-hidden', true );
    $('.EiPopupBg').hide();
    $('body').removeClass('no-scroll');
    $('#sidebar-cart').attr('tabindex',tabi );
}

var counterCookie = parseInt( getCookie( exit_intend_cookie_name ) );
if ( !counterCookie || counterCookie == undefined ){
  counterCookie = 1;  
  setCookie( exit_intend_cookie_name, counterCookie , 365 );
}



function showEi( ei_action ){
  
  if ( $('.EiPopupBg').is(':visible') ) return true;
  
  
  /*if ( getCookie( 'eintend_'+ei_action ) == 99 ) return true;  */
  setCookie( 'eintend_'+ei_action, 99, 10 );
    
  
  
  // add bg
  if ( $('.EiPopupBg').length == 0 ){
    $('body').append('<div class="EiPopupBg"></div>');
    $('.EiPopupBg').on('click',function(){      
      closeEi();
    });
  }
  
 
  
  if ( ei_action == 'basket'){ 
    
    if ( $('.EiPopup.PopupBasket').length == 0 ) return true;
    if ( ei_1 == ei_maxamount ) return true;
    ei_1++;
    
   
    
   	 $('#sidebar-cart').attr('tabindex','');
    
	$('.EiPopup.PopupBasket').attr('aria-hidden', false );
  	$('body').addClass('no-scroll');    
    
   
    addMailChimp( '.PopupBasket' );
    
  	$('.EiPopupBg').show();
    
    
    
  
  } else if ( ei_action == 'leave'){
    
    
    if( parseInt(getCookie( exit_intend_cookie_name ) )  > 3 ) return;
    
    if ( $('.EiPopup.PopupLeave').data('section-onindex') == true && $('.EiPopup.PopupLeave').data('template-name') != 'index' ) return true;    
    if ( $('.EiPopup.PopupLeave').length == 0 ) return true;
    if ( ei_2 == ei_maxamount ) return true;
    ei_2++;
    
 
    
    $('.EiPopup.PopupLeave').attr('aria-hidden', false );
  	$('body').addClass('no-scroll');
        
    addMailChimp( '.PopupLeave' );    
    $('.EiPopupBg').show();
    
    setCookie( exit_intend_cookie_name, ( parseInt( getCookie( exit_intend_cookie_name ) ) + 1) , 365 );
    
    
  } else if ( ei_action == 'inactive'){
    
    if ( $('.EiPopup.PopupInactive').length == 0 ) return true;
    if ( ei_3 == ei_maxamount ) return true;
    ei_3++;
    
    
    
    $('.EiPopup.PopupInactive').attr('aria-hidden', false );
  	$('body').addClass('no-scroll');
    
   
    addMailChimp( '.PopupInactive' );
    
  	$('.EiPopupBg').show();
    
    
  }
  
  
  
}

function exitIntend(){
  
  if ( $('.EiPopup').length == 0) return false;
  
  if ( $('#mc_embed_signup-default').data('logged') == true ) return false;

  // inactive
  if (  $('.EiPopup.PopupInactive').length > 0 ){
    
    $(this).mousemove(function (e) {
        ei_idletime = 0;
    });
    $(this).keypress(function (e) {
        ei_idletime = 0;
    });
    
    var idleInterval = setInterval(function(){
      ei_idletime = ei_idletime + 1;
      if ( ei_idletime > $('.EiPopup.PopupInactive').data('section-delay') ){        
        showEi( 'inactive' );
      }
    }, 1000); // 1 second
  }
    
  // basket
  if (  $('.EiPopup.PopupBasket').length > 0 ){
    if ( $('.EiPopup.PopupBasket').data('template-name') == 'cart' ){      
      if ( $('.EiPopup.PopupBasket').data('cart-total') < $('.EiPopup.PopupBasket').data('price') * 100 ){        
        
        
        showEi( 'basket');        
      }
    }
  }
  
  
  $('.EiPopup__Close').on('click',function(){
    
    if ( $(this).parents('.PopupLeave').length > 0 ){      
      setCookie( exit_intend_cookie_name, 55, 365 );
    }
    
   	closeEi();
  });
  
  
  
  
  if (/Chrome/.test(navigator.userAgent))
  {
    chrome = true;
    if ($(document).width() > ei_windowWidth ){
      ei_chromealert = false;
    }
  }
  
   $(document).bind('mousemove',function(e){
     ei_lastx = e.pageX;
     ei_lasty = e.pageY;
   });

  $(document).bind('mouseleave', function(e) { setTimeout(function(){ontheleave(e);}, ($('.EiPopup.PopupLeave').data('section-delay')*1000) ); });
  if ( isMobile ) ontheleaveMobile();

  if (chrome) {
    $(document).unbind("mouseleave");
    chromefix();
  }
  
   $(window).resize(function(e){
     ei_windowHeight = $(window).height();
     ei_windowWidth = $(window).width();
   });
  
 


}

/* EXIT INTEND POPUP  END */
var so = 0;

function scrollbar_small( ){
  
  if( $(window).scrollTop() > 0) { //abuse 0 == false :)      
    
    $('#section-header' ).addClass('header--isscrolled');    
    $('#section-header' ).removeClass('Header--transparent');
    
    if ( so == 0 ){
    	$('html').css('--header-height', $('#section-header').height()+"px" );    
    	document.documentElement.style.setProperty('--header-height', $('#section-header').height()+"px" );
      	so = 1;
    }
  
  } else {
    
    if ( $('#section-header' ).hasClass('smallever') ) return;    
    $('#section-header' ).removeClass('header--isscrolled');    
    
    $('html').css('--header-height', $('#section-header').height()+"px" );    
    document.documentElement.style.setProperty('--header-height', $('#section-header').height()+"px" );
    
    so = 0;
  }
  
 
}

function trustedShopReviews(){
  
  	// wenn wir keinen Ort zum Review einfügen haben - gleich wieder umdrehen - ist keine PDP Seite
  	if ( $('.bewertungZitate').length == 0 ) return;
  
  	if ( meta == undefined ) return;
  	if ( meta['product'] == undefined ) return;
	if ( meta['product']['variants'] == undefined ) return;
  
  
	if ( meta['product']['variants'].length > 0 ){
    	    	
      	var elemente = $('.bewertungZitate blockquote');

        if ( elemente.length > 0 ){

          var countChars = 0;
          var countReviews = 0;
          var maxChars = 200;
          var maxReviews = 3;

          $.each( elemente, function( index, review ){
            
			var commentOrg = $(this).html();
            var comment = commentOrg.substr(0, maxChars);                      	

            // nur das letzte Wort abschneiden wenn wir auch wirklich gekürzt haben
            if( comment != commentOrg ) comment = comment.substr(0, Math.min(comment.length, comment.lastIndexOf(" ")))

            if ( countReviews > 0 ){
               if ( countChars+comment.length > maxChars || countReviews+1 > maxReviews ){
                $(this).remove();
                return;
              }
            }

            $(this).html( comment );                      
            if ( comment != commentOrg ) $(this).html( comment+'<strong>&nbsp;&hellip;</strong>' );

            countReviews++;
            countChars += $(this).html().length;


          });  

          $('.bewertungZitate blockquote').on('click', function(){

            $('[data-action=toggle-collapsible]').attr('aria-expanded', false );

            var collapsibleTS = $('#collapse-tab1').parents('.Collapsible');                      
            var button = collapsibleTS.find('button');
            button.trigger('click');

            var collapsibleTS = $('#collapse-tab4').parents('.Collapsible');                      
            var button = collapsibleTS.find('button');
            button.trigger('click');

            button[0].scrollIntoView(true);
          });


        } else {

          $('#pdp_section_bewertung').remove();

        }
      
                
    }
  	
  
}

/*
reOrder wird erst komplett ausgeführt wenn alle js funktionen ausgeführt wurden
und der zähler entsprechend hochgezählt wurde

Das heisst Variablen müssen fertig sein und Bewertungen müssen fertig sein  


*/

function reOrderPDP(){
  

  var has_variants = false;
  var has_bewertungen = false;
  var has_geschenk = false;
  var has_konfigurator = false;
  

  
  // wenn wir uns nicht auf der PDP Seite befinden oder noch nicht alle JS Funktionen ausgeführt wurden
  if ( !$('body').hasClass( 'template-product' ) ) return;
  
  
  if ( $('#pdp_section_varianten').length > 0 ){
    has_variants = true;
  
  }
  
  if ( $('#pdp_section_bewertung').length > 0 ){
    has_bewertungen = true;
  
  }
  
  if ( $('#pdp_section_geschenk' ).length > 0 ){
    has_geschenk = true;
  
  }
  
  
  if ( $('#pdp_section_otk' ).length > 0 ){    
    if ( window.innerWidth > 730 && window.innerHeight > 980 ) has_konfigurator = true;  
  }
  
  // das element an das wir alles anhängen
  var anchor = $('.productview_desktop');
  
  // beide Zeilen generieren
  var firstLine = $('<div class="product-form-row"></div>');
  var secondLine = $('<div class="product-form-row"></div>');
  
  
  
  // 1. vorteile 6
  
  if ( $('#pdp_section_vorteile').find('li').length > 0 ){
  	firstLine.append( $('#pdp_section_vorteile') );
  }
  anchor.append( firstLine );  
  
  
  
  if ( ( has_geschenk || has_konfigurator ) && has_variants && has_bewertungen ){    
  // 2. vorteile 3 (wenn 6 einkürzen) + bewertungen / varianten + geschenk
  	
    if ( !isMobile ){
    	$('#pdp_section_vorteile').find('li').each( function( index, value ){      
      		if ( index > 2 ) $(value).remove();
    	});
     	
    }
    
    firstLine.append( $('#pdp_section_bewertung') );        
    secondLine.append( $('#pdp_section_varianten') );
    
    if ( has_konfigurator ){
      secondLine.append( $('#pdp_section_otk') );   
    } else secondLine.append( $('#pdp_section_geschenk') );   
    
  
  
  } else if ( has_bewertungen && ( has_geschenk || has_konfigurator ) ){
  // 3. vorteile 6 / bewertungen + geschenk
    
    
    
    secondLine.append( $('#pdp_section_bewertung') );
    if ( has_konfigurator ){
      secondLine.append( $('#pdp_section_otk') );   
    } else secondLine.append( $('#pdp_section_geschenk') );   
    
    
  } else if ( has_variants && has_bewertungen ){
  // 4. vorteile 6 / varianten + bewertungen    
    
    secondLine.append( $('#pdp_section_varianten') );    
    secondLine.append( $('#pdp_section_bewertung') );    
    
  } else if ( has_variants && ( has_geschenk || has_konfigurator ) ){
  // 5. vorteile 6 / varianten + geschenk
    
    
    
    secondLine.append( $('#pdp_section_varianten') );    
    if ( has_konfigurator ){
      secondLine.append( $('#pdp_section_otk') );   
    } else secondLine.append( $('#pdp_section_geschenk') );   
    
    
  } else if ( has_bewertungen ){
  // 6. vorteile 6 / bewertungen 
    
    secondLine.append( $('#pdp_section_bewertung') );    
    
  } else if ( has_geschenk || has_konfigurator  ){
  // 7. vorteile 6 / geschenk
    
    if ( has_konfigurator ){
      secondLine.append( $('#pdp_section_otk') );   
    } else secondLine.append( $('#pdp_section_geschenk') );   
    
  } else if ( has_variants ){
  // 8. vorteile 6 / varianten
    
    
    
    secondLine.append( $('#pdp_section_varianten') );    
    
  }
  
  
  
  
  anchor.append( secondLine );
    
  // zweite Zeile bloss anhängen wenn Childs vorhanden oder einspaltig machen
  if ( secondLine.children().length == 0 ) secondLine.remove();
  if ( secondLine.children().length == 1 ){
    secondLine.addClass('product-form-row-one');
    secondLine.removeClass('product-form-row');
  }
  
  // einspaltig machen wenn nur bewertungen da sind
  if ( firstLine.children().length == 0 ) firstLine.remove();
  if ( firstLine.children().length == 1 ){
    firstLine.addClass('product-form-row-one');
    firstLine.removeClass('product-form-row');
  }
  
  
  // das default view löschen 
  $('.productview_default').remove();
  
  
}


function catchNewsletterPrepare(){
  
  $('form.Footer__Newsletter').addClass('customCapturedForm');
  $('form.Newsletter').addClass('customCapturedForm');
  
  $('.customCapturedForm').attr('data-omnisend-captured-form',false);
  
  $('.customCapturedForm').attr('action','https://penoblo.us11.list-manage.com/subscribe/post-json?u=840449c90c45682c1a64375b2&id=fff13dd9dd&c=?');
  var emailaddress = $('.customCapturedForm').find('input[type=email]');
  emailaddress.attr('NAME', 'EMAIL' );
  emailaddress.attr('id', 'mce-EMAIL' );
  
  var emailaddress = $('.customCapturedForm').find('button[type=submit]');
  emailaddress.attr('NAME', 'subscribe' );
  emailaddress.attr('id', 'mc-embedded-subscribe' );
  
  $('.customCapturedForm').find('input[type=hidden]').remove();
  $('.customCapturedForm').append('<div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_840449c90c45682c1a64375b2_a7cd7f44cb" tabindex="-1" value=""></div>');
    
  
  $('.customCapturedForm').on('submit', function( e ){
     e.preventDefault();
     var form = $(this);
    
    
    
    
    
     $.ajax({
        type: form.attr('method'),
        url: form.attr('action'),
        data: form.serialize(),
        cache       : false,
        dataType    : 'json',
        contentType: "application/json; charset=utf-8",
        error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
        success     : function(data) {
          
           if ( $('.EiPopupBg').length == 0 ){
              $('body').append('<div class="EiPopupBg"></div>');
              $('.EiPopupBg').on('click',function(){      
                closeEi();
              });
            }


			$('#sidebar-cart').attr('tabindex','');

            
            $('body').addClass('no-scroll');   
            $('.EiPopupBg').show();
          
            if (data.result != "success") {
              
              if (data.msg.includes('already') ) {
                $('.PopupNewsletterInactive .EiPopup__Content').html('<p id="mce-error-response">Sie wurde für diesen Newsletter schon registriert.</p>');
              } else {
                $('.PopupNewsletterInactive .EiPopup__Content').html('<p id="mce-error-response">Beim Registrieren ist leider ein Fehler aufgetreten. Bitte versuchen Sie es nocheinmal.</p>');
              }
              	
              
              	
            } else {
              $('.PopupNewsletterInactive .EiPopup__Content').html('<p id="mce-success-response">Vielen Dank für Ihr Interesse am Newsletter.</p>');
                
            }
          
          	$('.PopupNewsletterInactive').attr('aria-hidden', false );	
          	$('.PopupNewsletterInactive').show();
        }
      });
  	
  	return false;
  });
  
}


function checkiPad(){
  
  var is_iPad = navigator.userAgent.match(/iPad/i) != null;
  if ( is_iPad ) $('body').addClass('iPad');
}
  

function toc(){
  
  const h = $('#section-header').height();
  $('.shopify-section').each( function(){
    $(this).find('h1,h2,h3,h4,h5,h6').each( function(){
      
      
      if ( $(this).attr('id') !== undefined ){
        const id = $(this).attr('id');
        $(this).attr('id','');
        let hiddenAnchor = $('<a id="'+id+'" class="hiddenAnchor" style="margin-top: -'+h+'px"></a>');
        $(this).prepend( hiddenAnchor );
      }
    })
  })
  $('.toc nav').hide();
  
  $('.toc p').on('click', function(){
     $('.toc nav').toggle()
  });
}

function flickity(){
  
  let flickitySetIndex = -1;
  $('.mobileOverlayScroll').on('click',function(){
    $(this).hide('fade');
    
    flickitySetIndex = $('.Product__Slideshow').flickity().data('flickity').selectedIndex
    $('.Product__Slideshow').flickity().flickity('option',{'draggable':false});
    $('.Product__Slideshow').flickity().flickity('deactivate');    
    $('.Product__Slideshow').flickity().flickity('activate');
    
   
       
    
  });
  
   $('body').on('click','.Product__Wrapper', function(){
      
      if ( flickitySetIndex == -1 || flickitySetIndex == $('.Product__Slideshow').flickity().data('flickity').selectedIndex ) return;
     
      flickitySetIndex = -1;    
      $('.Product__SlideItem--model .mobileOverlayScroll').show();
      $('.Product__Slideshow').flickity().flickity('option',{'draggable':true});
      $('.Product__Slideshow').flickity().flickity('deactivate');    
      $('.Product__Slideshow').flickity().flickity('activate');
      
      
       
    
    });
}

function addWeekendDays(max) {
  var tomorrow = Date.today();
  var weekendDays = 0;
  max = parseInt(max, 10);
  for (var i = 0; i < max; i++) {
    tomorrow.setDate(tomorrow.getDate() + 1);
    if ([0,6].indexOf(tomorrow.getDay()) !== -1) {
      weekendDays++;
    }
  }
  return max + weekendDays;
}

function getFirstNonWeekendDay() {
  var today = Date.today();
  while (true) {
    today.setDate(today.getDate() + 1);
    if ([0,6].indexOf(today.getDay()) === -1) {
      return today;
    }
  }
}

  
function initWeekendDays(){
  
  
  var min = Number.MIN_VALUE, max = Number.MIN_VALUE;
  $('.deliveryDatesAll [data-deliverydate]').each( function(){
    if ( $(this).data('deliverydate') !== undefined ){
    	var dates = $(this).data('deliverydate').split('-');
        if ( dates.length == 2 ){
			if ( dates[0] > min ) min = dates[0];
    		if ( dates[1] > max ) max = dates[1];
        }
    }
  });
  
  if ( min == Number.MIN_VALUE && max == Number.MIN_VALUE ){
    
    $('.fromDate').parent().html("Lieferzeit: nicht angegeben");
    $('.fromDate-delivery').parent().html("Lieferzeit: nicht angegeben");
    
  } else {
    
  
    $('.fromDate').html( min );
    $('.toDate').html( max );

    $('.fromDate-delivery').html( min );
    $('.toDate-delivery').html( max );
  }
 
 
 
  
}

function updateCart(){
  
  
  /*var observer = new MutationObserver(function(mutations) {

    mutations.forEach(function(mutation) {


     $('.Cart__ShippingNotice .Drawer__Container').html( $('.hiddenFreeDelivery').html() );

    });
  });

  observer.observe($('#sidebar-cart .Cart.Drawer__Content')[0], { attributes: false,childList: true, subtree: true });*/
  
  
}

$( document ).ready(function() {
  
   checkiPad();
   toc();
   flickity();
   catchNewsletterPrepare();
   initWeekendDays();
   //updateCart();

 
  
  $("body").on("click",".etrusted-tb-card > *",function(e){
      $(".PageTransition").hide();
  });
  
  /* Checkout Änderungen Dezember 2020 */
 
  
  /* Checkout Änderungen Dezember 2020 */
  // device detection
  if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
     || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
    isMobile = true;
  }
  
  
  if( $('.filter_button_outer').length > 0 && !isMobile ){
    let mw = 0;
    
    var minWidth = '134';    
    var collectionMinWidth = -1;
    if ( $('[data-width-filters]').length > 0 ){
      
      var collectionMinWidth = $('[data-width-filters]').data('width-filters');      
      if ( parseInt(collectionMinWidth) > minWidth ) minWidth = collectionMinWidth;
    } 
    
    
    
    $('.filter_button_outer').each( function(){
      if ( $(this).width() > mw ) mw = $(this).width();
    });
    
    if ( minWidth > mw ){
      mw = minWidth;
    }
  
    
    if ( mw > 0 ){
    	$('.filter_button_outer').css({'width': mw+'px' });
    }
   
  }
  
 
  
  mce_form = $('#mc_embed_signup').html();
  $('#mc_embed_signup').remove();
  
  
  
  var settings = $('#section-header').data('section-settings');
  
  if ( settings.smallScrollBar === true && !$('body').hasClass('template-cart') ){    
    scrollbar_small();
  }
  
  if ( settings.hasTransparentHeader ){
    if ( $(window).scrollTop() > 0 ){
       $('#section-header' ).removeClass('Header--transparent');
    }
  }
  
  $(window).scroll( function(){        
    ei_idletime = 0;
    if ( settings.smallScrollBar === true && !$('body').hasClass('template-cart') ) scrollbar_small();
  });
  
  
 
  /* REORDER FILTERS  SET BY COLLECTION TEMPLATE */
  exitIntend();
  
  
  
  document.addEventListener('otk-init', function(){
    $('#otto-hutt-konfigurator-add').addClass('Button');
  	$('#otto-hutt-konfigurator-add').addClass('Button--primary');
  });
  
  document.addEventListener('otk-add-to-cart', function(e){
	refreshCart();
    showCart();
  	//$('[data-drawer-id="sidebar-cart"]').trigger('click');
  });
    
  
  
  
  var sortJson = $('#collection-filter-drawer').attr('data-sort');  
  if ( sortJson != undefined ){
    var collection_filter_sort = $.parseJSON( sortJson );

    $.each( collection_filter_sort, function( tag_base, tag_options ){

      for ( var i = 0; i < tag_options.length; i++ ){

          var i1 = tag_options.length-1;
          var tag = tag_options[i1-i];    
          var elements = $('[data-tag='+tag+'][data-action=toggle-tag]');

          elements.each( function( index, value ){
            var parent = $(this).parents();
            var parent1 = $(parent[0]);
            var parent2 = $(parent[1]);


            if ( parent1.is("LI") ){           

              // Filter Sidebar
             
              parent2.prepend( parent1 );
            } else {
              // Filter Collection Bar
              $( parent1 ).prepend( $(this) );
            }

          });

      }    

    });
  }
  
  
  document.addEventListener('theme:loading:end', function(){    
    
    updateEngraving();  
  });
    

  var leaveMenu = false;

  // isMobile = true;
  
  if ( !isMobile ){
    
    // Menu nachladen
    var url = "//weidlor-shop.shop/cdn/shop/t/3/assets/menu.reload.txt?v=171968168020092202551793628574";
    var assetUrl = url.split('menu.reload.txt')[0];
    
    if ( window.location.href.includes('menuhardreload') ){
      url = url + Math.floor(Math.random() * 100) + Date.now();
    }
    
    var request = new XMLHttpRequest();
    request.open('GET', url);
    request.responseType = 'text';

    request.onload = function() {
      
      
     let response= request.response;
     /*var matchedAll = request.response.matchAll(/(\{\{[\s]{0,}'([^']+)[^}]+)/g)
      for (let group of matchedAll ) {

        let all = group[1] + '}}';
        let file = group[2];
        //console.log( group[1].trim() );
        response = response.replace(all.trim(), assetUrl + file);
      }*/

      let matches = response.match(/(\{\{[\s]{0,}'([^']+)[^}]+)/g);
      for ( const i in matches ){
          group = matches[i];
          let all = group + '}}';
          let t = all.match(/'(.*)'/g);

          let file = t[0].substr(1,t[0].length-2);
          let fileAsset = assetUrl+file;
          response = response.replace( all, fileAsset);

      }

      let matches2 = response.match(/href="([a-zA-Z][^"]+)"/g)
      for ( const i in matches2 ){

        group = matches2[i];
        

        if ( group.includes('href="http') ) continue;

        if ( !group.includes('href="/') ) groupNew = group.replace( 'href="', 'href="/' );

        if ( !groupNew.includes('href="/collections') && groupNew.includes('/collections') ){
          groupNew = groupNew.replace( '/collections/', '/' );
          groupNew = groupNew.replace( 'href="/', 'href="/collections/' );
        }

        response = response.replace( group, groupNew);

      };
      
      response = response.replace(/<h4/ig,'<p class="orgh4"');
      response = response.replace(/<\/h4/ig,'</p');
      
      
      
      $('#menu-main').html( response );
      
      // init menu
      $('[data-menu]').hide();
      $('[data-menu=menu--parent]').show();

      $('#menu-main>li').on('mouseenter',function( e ){
        e.preventDefault();

        $('.menu-sub').hide();
        $(this).children('.menu-sub').show();

        leaveMenu = true;
      });

      $('.menu-sub').on('mouseleave',function( e ){
        e.preventDefault();

        if ( leaveMenu == false ) return;

        $('[data-menu]').hide();        
        $('[data-menu=menu--parent]').show();
        $('.menu-sub').hide();
      });


      $('[data-menu-action]').on('click', function( e ){


        e.preventDefault();
        leaveMenu = false;

        var menu = $( this ).attr('data-menu-action');


        if ( menu == 'menu--back' ){

          $('[data-menu]').hide();
          $('[data-menu=menu--parent]').show();

          setTimeout( function(){ leaveMenu = true }, 500 );
          return;

        }

        $('[data-menu]').hide();
        $('[data-menu='+menu+']').show();                    
        $('[data-menu='+menu+']').css({ display: 'grid' });
        $('[data-menu=menu--parent]').hide();

        setTimeout( function(){ leaveMenu = true }, 500 );



      });
    };

    request.send();
    
  } else  {
    
    var menubg = undefined;
    menubg = $('<div>');
    menubg.css({
      'position': 'absolute',
      'top': '0px',
      'bottom': '0px',
      'left': '0px',
      'right': '0px',
      'z-index': 1   
    });

    $('body').append( menubg );
    menubg.hide();

    $('.menu-sub a').on('click',function(){      	
    	if ( !$(this)[0].hasAttribute('data-menu-action' ) ) window.location.href = $(this).attr('href');
    });
    
    $('#menu-main>li').on('click',function( e ){
      
      if ( $(this).children('.menu-sub').length == 0 ){
        window.location.href = $(this).children('a').attr('href');
      }
      
      e.preventDefault();  
      

      if ( !$(this).children('.menu-sub').is(':visible') ){
        
        $('[data-menu]').hide();        
        $('[data-menu=menu--parent]').show();
        $('.menu-sub').hide();

        $(this).children('.menu-sub').show();
        menubg.show();
        leaveMenu = true;

      } else {
        
        if ( leaveMenu == false ) return;

        $('[data-menu]').hide();        
        $('[data-menu=menu--parent]').show();
        $('.menu-sub').hide();
        menubg.hide();
      }


      leaveMenu = true;
    });

    $(menubg).on('click',function( e ){
      e.preventDefault();
      menubg.hide();
      if ( leaveMenu == false ) return;

      $('[data-menu]').hide();        
      $('[data-menu=menu--parent]').show();
      $('.menu-sub').hide();
    });
    
  }


               
               
  function updateEngraving(){    
   	
	
    // supress ajax reload for pure cart page
    if ( $('body').hasClass('template-cart') ){      
      $('.PageOverlay').addClass('is-visible');      
    }

    

    jQuery.getJSON('/cart.js', function( retval ){
      
      
      var reload = false;
      
      
	
      var ob = {};
      //var retval = $.parseJSON( retval.responseText );

      ob[ engraving_cost ] = 0;
      ob[ engraving_free ] = 0;
      
      allowed_gifts = {};

      for ( var i = 0; i < retval['items'].length; i++ ){
        var item = retval['items'][i];
        
        if ( item['properties'] == null ) continue;  
        
        // die erlaubten geschenke zu einer liste hinzufügen
        if ( item['properties']['_can_have_gift'] != null ){
          var temp = item['properties']['_can_have_gift'].split('|');
          temp.pop();
          
          for ( i1 = 0; i1 < temp.length; i1++ ){
            
            
            var res = temp[i1].split(':');
      
      		var giftid = res[2];
      		var giftpos = res[1];      
            allowed_gifts[ giftid ] = 1;
          }
        }
        
       
        if ( item['properties']['engraving'] != null ){

          // nur die items durchgehen die eine Gravur haben und dann den preis checken
          if ( item['id'] != engraving_free && item['id'] != engraving_cost && item['properties']['engraving'].length > 0 ){

            if ( item['price'] < engraving_cost_under ){
              ob[ engraving_cost ] += item['quantity'];
            } else {
              ob[ engraving_free ] += item['quantity'];
            }

          }
        }
        
        
      }      
      
      for ( var i = 0; i < retval['items'].length; i++ ){
        var item = retval['items'][i];
        
        if ( item['properties'] == null ) continue;        
        if ( item['properties']['_is_gift'] != null ){          
          
          
          
          // überprüfen ob das gefundene geschenk überhaupt erlaubt ist - lässt eines der Produkte im Warenkorb dies zu ?
          if ( allowed_gifts[ item['product_id'] ] != null ){
            //
          } else {
            // wenn nicht das Geschenk rauswerfen            
            ob[ item['id'] ] = 0;
            
          }
          
        }

      }
      
       
      
	 
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {updates: ob },
        async:false
      }).always(function() {        	

        if ( $('body').hasClass('template-cart') ){
          document.location.reload();
        } else {

          refreshCart();
        }

      });

    });
      
   
    
  }
  
  
  
  $('.adminview_info_button').on('click', function(){
    $('.adminview_hidden').toggle();
  });
  
  
  $('.editCollection button').on('click', function(){
      window.open( $(this).attr('data-url'),'_blank');    
  });
  
  
  trustedShopReviews();
  reOrderPDP();  
  
  // VARIANTEN 
  if ( $('.product-color-variant-div' ).length > 0 ){    
   
    $('.product-color-variant-slider').css({'display':'block'});
    let cellA = 'left';
    let add = true;
      
    if ( $('.product-form-row-one .product-color-variant-div').length <= 5 && $('.product-form-row-one .product-color-variant-div').length > 0 && !isMobile ){
      $('.product-color-variant-slider').addClass('leftMarginNull');
      add = false;
    }

    if ( $('.product-form-row .product-color-variant-div').length <= 2 && $('.product-form-row .product-color-variant-div').length > 0 && !isMobile ){
      $('.product-color-variant-slider').addClass('leftMarginNull');
      add = false;
    }


    window.dispatchEvent(new Event('resize'));
    if ( add ){
      $('.product-color-variant-slider').flickity({
        "cellAlign": cellA,
        "contain": true,
        "pageDots": false,
        "groupCells": true,
        "imagesLoaded": true,
        "arrowShape": 'M 35,50 L 60,95 L 70,95 L 45,50  L 70,5 L 60,5 Z'        
      });
    }
  
    $('.product-color-variant-div').on('mouseenter', function(){         
      var p = $('<img src="'+$(this).data('preview')+'" class="previewWindowBig">');
      $('.product-color-variant-slider').prepend( p );
    });

    $('.product-color-variant-div').on('mouseleave', function(){         
      $('.previewWindowBig').remove();
    }); 
    
    
  } else {
    
    var parent = $('.colorvariantsslide').parent();
    $('.colorvariantsslide').remove();
    
    if ( parent.children().length > 0 ){
  		parent.addClass('product-form-row-one').removeClass('product-form-row');
    } else {
      parent.remove();
    }
  }
  // VARIANTEN ZUM PRODUKT HINZUFÜGEN ENDE
  
  $('.tooltip_a').each( function( index, element ){     
    
    
    var tooltip = $(element).parent().find('.hidden-bage');
 
    
    if ( tooltip.length == 0 ) return;
    tippy( element, { content: tooltip.html(),duration: [0,0] })
  });
  
  
  
  
  
  
  
   
  
  	$('[data-handle]').on('click', function( e ){  
      
      e.preventDefault();
      
            
      
	      
      $('.handle-mega-sub-hidden').hide();
      $('.handle-mega-sub-'+$(this).attr('data-handle') ).show();
          
      $( this ).parents('.MegaMenu').attr('area-hidden', false );
      
      var mm = $( this ).parents('.MegaMenu');
      var height = mm.outerHeight();     
      mm.css('min-height', height+'px' );

      return false;


	});
  
  $('.MegaMenu').on('mouseleave', function(){
    $('.handle-mega-sub-hidden').hide();
    $( this ).css('min-height', 'auto' );
  });
  
  /*
  Kollektion 2020
  */
 
  
  
  $('#collection-filter-drawer .Drawer__Header').on('click', function(){    
    
    
    if ( $(this).find('button').hasClass('show-area-open') ){
        $(this).find('button').removeClass('show-area-open'); 
        $(this).next().hide().data('aria-hidden', true );
      
	} else {
		$(this).find('button').addClass('show-area-open');
  		$(this).next().show().data('aria-hidden', false );
      
    }
    
    if( $('[data-drawer-id=show-area--filter] button').hasClass('show-area-open') ){
      $('#show-area--sort').css({'height':'inherit'});
      console.log('max')
    } else {
	  $('#show-area--sort').css({'height':'auto'});
      console.log('min')
    }
                                         
   
    
    
  });
  
  $('#show-area--sort .Linklist__Item').on('click', function(){
    $('#show-area--sort .Linklist__Item.is-selected').removeClass('is-selected');
    $(this).addClass('is-selected');
    $('#collection-sort-popover .Popover__Value[data-value='+$(this).data('value')+']').trigger('click');
  });
  
  $('[data-drawer-id=collection-filter-drawer]').on('click', function(){    
    
    
    $('[data-drawer-id=show-area--filter] button').addClass('show-area-open');
    $('#show-area--filter').show();
    
    
  })
  
 
  
  function addAdvertisment(){
    
    var el = $('[data-collection-builder]');
    if ( el.length == 0 ) return;
    
    var data = el.data('collection-builder');
    if ( data == null || data == undefined ) return;
    
    
    $('.Grid__Cell--advertisment').remove();
        
    var perRow = $('.template-collection .ProductList--grid').data('mobile-count');
    var device = 'phone';    
    
    if ( $(window).width() > 640 ){
      perRow = $('.template-collection .ProductList--grid').data('tablet-count');
      device = 'tablet-and-up';
      
    }
    if ( $(window).width() > 1007 ){
      perRow = $('.template-collection .ProductList--grid').data('desktop-count');
      device = 'lap-and-up';
    }
    
  	const banners = ['banner','banner1','banner2','banner3','banner4'];
    const bannersToAdd = [];
  
    for ( const bannername of banners ){
    
    var imgurl = '';
    var posdata = [];
      
      const bann = {
        banner_img_mobile: data[bannername+'_img_mobile' ],
        banner_size_mobile: data[bannername+'_size_mobile' ],
        banner_img_tablet: data[bannername+'_img_tablet' ],
        banner_size_tablet: data[bannername+'_size_tablet' ],
        banner_img_desktop: data[bannername+'_img_desktop' ],
        banner_size_desktop: data[bannername+'_size_desktop' ],
        
        banner_color: data[bannername+'_color' ],
        banner_box_align: data[bannername+'_box_align' ],
        banner_box_justify: data[bannername+'_box_justify' ],
        banner_headline: data[bannername+'_headline' ],
        banner_headline_size: data[bannername+'_headline_size' ],
        banner_headline_size_mobile: data[bannername+'_headline_size_mobile' ],
        
        banner_button_link: data[bannername+'_button_link' ],
        banner_button_text_size: data[bannername+'_button_text_size' ],
        banner_button_text_size_mobile: data[bannername+'_button_text_size_mobile' ],
        banner_button_text: data[bannername+'_button_text' ],
        
        banner_image_link: data[bannername+'_image_link' ],
        banner_deactive: data[bannername+'_deactive' ],
      }
      
     if ( bann.banner_deactive ) continue;
      if ( bann === undefined ) continue;
      
      
    if ( device == 'phone' ){
        if ( bann.banner_img_mobile != undefined ){
          imgurl = bann.banner_img_mobile;
          posdata = bann.banner_size_mobile.split('/');
          
          bann.banner_headline_size = bann.banner_headline_size_mobile;
          bann.banner_button_text_size = bann.banner_button_text_size_mobile;
      }
    }
    
    if ( device == 'tablet-and-up' ){
        if ( bann.banner_img_tablet != undefined ){
          imgurl = bann.banner_img_tablet;
          posdata = bann.banner_size_tablet.split('/');
      }
    }
    
    
    if ( device == 'lap-and-up' ){
        if ( bann.banner_img_desktop != undefined ){
          imgurl = bann.banner_img_desktop;
          posdata = bann.banner_size_desktop.split('/');
      }
    }
    
      if ( imgurl.length == 0 ) continue;
  
    
  	// keine Positionsangaben keine Ausgabe
      if ( posdata.length < 3 || posdata.length == 0 ) continue;
    
  	var bg = '';
  	if ( imgurl.trim().length > 0 ){
      bg = 'background-image: url('+imgurl+')';
    }
    
    var width = parseInt( parseInt(posdata[2]) );
  	var line = parseInt( parseInt(posdata[0]) )-1;
  	var column = parseInt( posdata[1] )-1;
  
    
    var pos = perRow*line;
    pos += column;    
    if ( width+column > perRow ) width = perRow-column;
    
  
    
    var heightAdvert = $('.template-collection .ProductList--grid .Grid__Cell').height();
    
      var advert = $('<div class="Grid__Cell Grid__Cell--advertisment" style="height: '+heightAdvert+'px; color: '+bann.banner_color+'"></div>');
      
      
      var innerAdvert = $('<div class="advert  advert_box--'+bann.banner_box_align+' advert_vbox--'+bann.banner_box_justify+'" style="'+bg+' "></div>');
      if ( bann.banner_image_link !== undefined ){
      	if ( bann.banner_image_link.trim().length > 0 ){
        	innerAdvert.append( $('<a class="advert-imagelink" href="'+bann.banner_image_link.trim()+'"></a>'))
       
	      }
      }
      
    
    var inner = $('<div class="advertisment_box"></div>');
      if ( bann.banner_headline.trim().length > 0 ){
      fontsize = '1.5rem';
        fontsize = bann.banner_headline_size;
        inner.append( $('<h2 class="Heading u-h1" style="font-size: '+fontsize+';">'+bann.banner_headline+'</h2>') );
    }
    
      if ( bann.banner_button_link.trim().length > 0 ){
      fontsize = '1rem';
        fontsize = bann.banner_button_text_size;
      
      let blank = 'target="_blank"';
        if ( bann.banner_button_link.split('#').length == 2 ){
          if ( bann.banner_button_link.split('#')[0].trim() === '' ){
          blank = '';
        }
      }
        inner.append( $('<a href="'+bann.banner_button_link+'" '+blank+' class="linkasbutton-Button" style="font-size: '+fontsize+';">'+bann.banner_button_text+'</a>') );
    }
    
    innerAdvert.append( inner );
    advert.append( innerAdvert );
    advert.addClass( width+'/'+perRow+'--'+device);
    
      bannersToAdd.push({
        position: pos,
        breite: width,
        werbung: advert,
      });
      
    }
    
    bannersToAdd.sort((a,b)=>{
      let comparison = 0;
      if (a.position > b.position) {
        comparison = 1;
      } else if (a.position < b.position) {
        comparison = -1;
      }
      return comparison; 
    });
    
    let insertPos = 0;
    for ( const banner of bannersToAdd ){
      
      
      let pos = banner.position+insertPos;
      
    if ( pos > 0 ){
          banner.werbung.insertAfter( $('.template-collection .ProductList--grid .Grid__Cell:nth-child('+pos+')') );  
    } else {
          $('.template-collection .ProductList--grid').prepend( banner.werbung );  
    }
      insertPos = insertPos-banner.breite+1;
     
      
      
    }
    
    
    
  }
  
  if ( $('body').hasClass('template-collection') ){
    
    document.addEventListener('theme:loading:end', function(){
      
      if ( $('.Pagination').length > 0 ){
       
        $('.articlesCount span').html( $('.Pagination').data('items')  );
      } else {
        
      	$('.articlesCount span').html( $('.CollectionInner__Products .ProductItem').length );
      }
    });
    
    addAdvertisment();
    $(window).resize(function(e){ addAdvertisment(); });
    
  }
  
  if ( !isMobile ){
    $('body').addClass('pageDesktop');
  }
  
  
 /* Kollektionen 2020 ende */
  
  
  $('.Filter_List_Button').each( function( index, element ){       	
      var c = $('.'+$(element).attr( 'data-action' )+' .Collapsible__Inner' ).html();
      tippy( element, {
        content: c,
        duration: [0,0],
        arrow: true,
        distance: 20,
        theme: 'penoblo',
        placement: 'bottom',
        popperOptions: {
          positionFixed: true
        },
        trigger: 'click',
        onShown: function() {
          
          	$('.tippy-tooltip .tippy-content').removeClass('removeFilterOverflow');
          
          	if ( $('.tippy-tooltip .tippy-content .colorswitchgrid').length > 0 ){
              $('.tippy-tooltip .tippy-content').addClass('removeFilterOverflow');
          	}
          	
          
          
          	$('.tippy-tooltip .Filter_List_Values button.is-active').removeClass('is-active');
          	
          	$('.Drawer__Main .is-active').each( function( index, element ){            
            	var tag = $(element).attr('data-tag');              
            	$('.tippy-tooltip .Filter_List_Values [data-tag='+tag+']').addClass('is-active');
            
          	});
          
          	$('.tippy-tooltip .Filter_List_Values button').off('click');
     		$('.tippy-tooltip .Filter_List_Values button').on('click',function(){
              
             
              var tag = $(this).attr('data-tag');
              /*if (tag=="produkttyp_fueller") {
                tag = "produkttyp_Fuller";
              }*/
              $('.Drawer__Main [data-tag='+tag+']').trigger('click'); 
              $('[data-action=apply-tags]').trigger('click');
              
            });
     	}
      });
    
    	
    
  });
  
  function getFilterOptions( drop ){
    
    var elems = $('.Drawer__Main .is-active');
    var size = elems.length;
    
    
    
    $('.Filter_List_Button').removeClass('is-active');
    
    /*if (  $('[data-drawer-id=collection-filter-drawer] span.Text--subdued').length == 0 ){
      $('[data-drawer-id=collection-filter-drawer]').append('<span class="Text--subdued"></span>');
    }*/
    
    $('.filter_additional').remove();
              
    if ( size > 0 && typeof drop != 'boolean' ){
      $('[data-drawer-id=collection-filter-drawer] span').html('('+size+')');
      
      elems.each( function( index, elem ){
        
        
       
        
      	var tag = $(elem).attr('data-tag');
      
      	var button = $('.Filter_List [data-tag='+tag+']').attr('data-button');     
      	$('[data-action='+button+']').addClass('is-active');
        
        
        var filter =  $( '<span class="filter_active_desktop filter_additional" data-action="remove-tag" data-tag="'+tag+'"></span>' );
        filter.append( '<svg aria-hidden="true" data-prefix="fas" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512" class="svg-inline--fa fa-times fa-w-11 fa-2x"><path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z" class=""></path></svg>' );
        
        var span = $(elem).find('span');
        if ( span.length > 0 ){
          filter.append( $(span).html() );    
        } else {
          filter.append( $(elem).html() );    
        }
        
        
        filter.on('click', function(){
          var tag = $(this).attr('data-tag');
          $('.Drawer__Main [data-tag='+tag+']').trigger('click'); 
          $('[data-action=apply-tags]').trigger('click');
          $(this).remove();
          getFilterOptions();
          
          
        });
         
        
        $('.Filters_Desktop__Active').append( filter );
      
      });
      
    } else {
      $('[data-drawer-id=collection-filter-drawer] span').html('');
    }
    
    
    if( $('.filter_active_desktop').length == 1 ){
      $('.Filters_Desktop__Active').hide();
      $('.CollectionMain .CollectionInner').css({'padding-top': 0 });
    } else {
      $('.Filters_Desktop__Active').show();
      $('.CollectionMain .CollectionInner').css({'padding-top': $('.Filters_Desktop__Active').height() });
    }
   
  }
  
  
  // filter einstellungen übernehmen
  $('[data-action=apply-tags]').on('click', getFilterOptions );
  $('.CollectionInner__Products').on('click', '[data-action=reset-tags]', function(){ getFilterOptions( true ); });
  
  if ( $('[data-remove-filter=all]').length > 0 ){
    
    $('[data-remove-filter=all]').on('click',function(){
      
      $('[data-action=reset-tags]').trigger('click');
      getFilterOptions( true );
      
    });
    
  }
  
  getFilterOptions();
  
 
 
    var upselling_list = {
    'waldmann' : {
		'fueller' : '/collections/tintenpatronen/products/waldmann-refills-tintenpatronen',
		'kolbenfueller' : '/collections/tintenfasser-1/products/waldmann-refills-tintenglas-30ml',
		'kugelschreiber' : '/collections/kugelschreiber-refills/products/waldmann-refills-kugelschreiber-mine-rohrchen',
		'tintenroller' : '/collections/montegrappa-rollerball-minen/products/waldmann-refills-rollberball-mine-rohrchen',
		'bleistift' : '/collections/bleistift-minen/products/waldmann-refills-bleistift-minen'
    },
    'montegrappa' : {
        'kolbenfueller' : '/collections/tintenfasser-1/products/montegrappa-refills-fuller-tintenfass',
        'kugelschreiber' : '/collections/kugelschreiber-refills/products/montegrappa-refills-kugelschreiber-gross-minen-breit',
    },
    'graf-von-faber-castell' : {
        'fueller' : '/collections/tintenpatronen/products/graf-von-faber-castell-tintenpatronen-20x-in-geschenkverpackung-cobaltblau',
        'kolbenfueller' : '/collections/tintenfasser-1/products/graf-von-faber-castell-tintenglas-75ml-royal-blue',
        'kugelschreiber' : '/collections/kugelschreiber-refills/products/graf-von-faber-castell-kugelschreibermine-m-blau',
        'tintenroller' : '/collections/montegrappa-rollerball-minen/products/graf-von-faber-castell-tintenrollermine-intuition-blau',
        'bleistift' : '/collections/bleistift-minen/products/graf-von-faber-castell-12-bleistiftminen-07-b',
    },
    'pelikan' : {
        'fueller' : '/collections/tintenpatronen/products/pelikan-tintenpatrone-edelstein-tinte-gtp6-tanzanite-metalletui',
        'kolbenfueller' : '/collections/tintenfasser-1/products/pelikan-tintenglas-koenigsblau',
        'kugelschreiber' : '/collections/kugelschreiber-refills/products/pelikan-kugelschreibermine-blau-m',
        'tintenroller' : '/collections/montegrappa-rollerball-minen/products/pelikan-rollermine-tecflex-blau-b',
    },
    'kaweco' : {
        'fueller' : '/collections/tintenpatronen/products/kaweco-refills-tintenpatronen-koenigsblau-6-stuck',
        'kolbenfueller' : '/collections/tintenfasser-1/products/kaweco-refills-tintenglas-koenigsblau-30-ml',
        'kugelschreiber' : '/collections/kugelschreiber-refills/products/kaweco-refills-kugelschreibermine-blau-1-0-ve-3-1',
        'bleistift' : '/collections/bleistift-minen/products/kaweco-refills-bleistiftminen-blau-2-0-x-80',
    },
    'cerruti-1881' : {
        'kugelschreiber' : '/collections/kugelschreiber-refills/products/cerruti-kugelschreibermine-blau-metall-m',
        'tintenroller' : '/collections/montegrappa-rollerball-minen/products/cerruti-tintenrollermine-blau-metall-m',
    },
    'cross' : {
        'fueller' : '/products/cross-tintenpatronen-blau-loschbar-schachtel-mit-6-stuck',
        'kugelschreiber' : '/collections/kugelschreiber-refills/products/cross-kugelschreiberminen-blau-b-blisterkarte-mit-2-minen',
        'bleistift' : '/collections/bleistift-minen/products/cross-bleistift-minen-09-mm-blisterkarte-mit-15-minen',
    },
    'montblanc' : {
		'fueller' : '/collections/montblanc-refills/products/montblanc-tintenpatronen-royal-blue-8-stk',
		'kolbenfueller' : '/collections/montblanc-refills/products/montblanc-tintenglas-royal-blue-60-ml',
		'kugelschreiber' : '/collections/montblanc-refills/products/montblanc-kugelschreibermine-pacific-blue-2x-mittel',
		'tintenroller' : '/collections/montblanc-refills/products/montblanc-tintenrollermine-pacific-blue-2x-mittel',
    },
    'carandache' : {
		'fueller' : '/collections/caran-dache-refills/products/caran-dache-tintenpatronen-chromatics-paeckchen-mit-6-stueck-idyllic-blue',
		'kolbenfueller' : '/collections/caran-dache-refills/products/caran-dache-tintenglas-idyllic-blue',
		'kugelschreiber' : '/collections/caran-dache-refills/products/caran-dache-kugelschreibermine-goliath-blau-medium',
		'tintenroller' : '/collections/caran-dache-refills/products/caran-dache-tintenrollermine-blau-fein',
    },
    'lamy' : {
		'fueller' : '/collections/lamy-refills/products/lamy-tintenpatrone-t10-blau-schwarz',
		'kolbenfueller' : '/collections/lamy-refills/products/lamy-tintenglas-t53-crystal-tinte-azur-blau',
		'kugelschreiber' : '/collections/lamy-refills/products/lamy-kugelschreibermine-m22-blau',
		'tintenroller' : '/collections/lamy-refills/products/lamy-tintenrollermine-m66-blau',
    },
    'diplomat' : {
		'fueller' : '/collections/diplomat-refills/products/diplomat-tintenpatronen-6er-packung-konigsblau',
		'kolbenfueller' : '/collections/diplomat-refills/products/diplomat-tintenglas-30-ml-blau',
		'kugelschreiber' : '/collections/diplomat-refills/products/diplomat-kugelschreibermine-easyflow-grossraum-blau',
		'tintenroller' : '/collections/diplomat-refills/products/diplomat-tintenrollermine-blau',
        'bleistift' : '/collections/diplomat-refills/products/diplomat-bleistiftmine-hb-excellence-12-st'
    }
  };
  
  var url_konverter_fueller = '/collections/konverter-fur-fuller/?view=ajax';  
  var upselling_vendor = $('.meta_upselling_vendor').html();
  var upselling_type = $('.meta_upselling_type').html();
  
  if ( upselling_list[upselling_vendor] == undefined ){
    upselling_vendor = 'graf-von-faber-castell';
  }
  
 
  // changed 13.11.2018 ps
  if ($('.single_upsell_product .price_upsell .money').length>0) {
  	var currency = $('.single_upsell_product .price_upsell .money').html().split(' ')[1];
  }
  
   $('#upsell-closer').on('click', function(){
     $('#sidebar-cart-upselling').hide();
   });
  
  // Product Geschenke - ANFANG
  var giftButton = $('.ProductForm__Gift' );
  if ( giftButton.length > 0 ){    
    
    
    var gifts = [];
    $('.product_gift').each( function( index, value ){
      
       
      var res = $(this).attr('data-gift').split(':');
      
      var giftid = res[2];
      var giftpos = res[1];      
      gifts.splice(giftpos, 0, giftid);      
    });
    
    if ( gifts.length > 0 ){
      
     
      
      $.getJSON(webserviceUrl+'/shopify_weidler/product_list?art='+gifts.join(','), function( data ){
        
        var cartKeys = {};
        $('.CartItem__Remove').each( function( index, value ){
          var key= $(this).attr('data-line-id').split(':');
          cartKeys[ key[0] ] = key[1];
        })
        
        
        $('.gift-message').hide();
        $('.gift-message-inner').html('');
        
        
        $.each( data['data']['products'], function( index, value ){
          
          if ( value['variants'][0]['inventory_quantity'] < 1 ) return;
          
          var title = value['title'];          
          var vendor = value['vendor'];
          var id = value['variants'][0]['id'];
          var image_src = value['image']['src'];
          var price = 'GRATIS';

          vendor = title.split(',')[0];
          titleParts = title.split(',').splice(1);
          
		
          
          title = titleParts.join(',');
          

          

          
          var giftMessage = $('<div class="gift-message"><div class="gift-message-inner-table"><div class="gift-message-inner"></div></div></div>');
          var image = $('<div class="single_gift_product_image"  data-product-id="'+id+'" data-product-parent="'+value['id']+'"><img class="" src="'+image_src+'"></div>' );

          var subtext = $( '<p><strong>'+vendor+'</strong><br><span class="price subline_gift">'+title+'</span><span class="footer-text-p  price_gift">'+price+'</span></p>' );

          var upselling_product = $('<div class="single_gift_product"></div>');


          
          image.append( giftMessage );
          image.on('click', upsellingadd );
          upselling_product.append( image );
          upselling_product.append( subtext );

          $('.gift-product-list').append( upselling_product );
          
          if ( cartKeys[ id ] != undefined ){
            
            
              
              giftMessage.show();
              var msinner = giftMessage.find( '.gift-message-inner');
              msinner.html( '&#10003;' );
              msinner.css({
                'color': 'green',
                'font-size': '5rem'
              });
            
            
          }
          
        });
        
        
        $('#gift-closer').on('click',closeGifts);
       
        
        giftButton.on('click', showGifts );
        
      });
      
      function showGifts(){
        
        $('html').addClass('no-scroll');
        $('.PageOverlay').addClass('is-visible');          
        $('#sidebar-cart-gift').show();          
        $('.PageOverlay').on('click', closeGifts );
        
        
        $('.gift-product-list').flickity({
         "cellAlign": "center",
         "contain": true,
         "pageDots": false,
         "groupCells": true,
         "imagesLoaded": false
       });
        
      }
      
      function closeGifts(){
        $('html').removeClass('no-scroll');
        $('.PageOverlay').removeClass('is-visible');
        $('#sidebar-cart-gift').hide();
        
        
      }
      
      
    }
    
  	
  }
  // Product Geschenke - ENDE
  

  function upsellSlide(){
     $('.upselling-product-list').flickity({
         "cellAlign": "left",
         "contain": true,
         "pageDots": false,
         "groupCells": true,
         "imagesLoaded": false
       });
    
  }
  
  
  
  
  // Variable Upselling Daten hinzufügen
  if ( $('.upselling_tags').length > 0 ) {
    
    if ( $('.upselling_tags span').length > 0 ){
    
      	var tagsString = '';
      
      
      
      	$('.upselling_tags span').each( function(){
          tagsString += $(this).html()+',';
      	});
      	tagsString = tagsString.substr(0,tagsString.length-1);
      

         $.getJSON(webserviceUrl+'/shopify_weidler/upsell_articles?tags='+tagsString, function( data ){
           data = data['data'];
           if ( data['articles'].length == 0 ){
             $('#sidebar-cart-upselling').remove();
             return;
           }

           $.each(data['articles'], function( index, url ){

            var urlload = '/products/'+url;
            $.ajax({
                url: urlload+'.json',
                async: false,
                data: [],
                success: function( data ){

                  var pr = data;
                  var title = pr.product.title;
                  var href = urlload;
                  var vendor = pr.product.vendor;
                  var id = pr.product.variants[0].id;
                  var image_src = pr.product.image.src;
                  var price = pr.product.variants[0].price+" "+currency;

                  titleParts = title.split(',').splice(1);

                 
                  title = titleParts.join(',');


                  var cartButton = $('<div class="upselling-addToCart" data-product-id="'+id+'" >In den Warenkorb</div>' );
                  var image = $('<div class="single_upsell_product_image"><a href="'+href+'" class="upsalling-a"><img class="" src="'+image_src+'"></a></div>' );

                  var subtext = $( '<p><strong>'+vendor+'</strong><br><span class="price subline_upsell">'+title+'</span><span class="footer-text-p  price_upsell">'+price+'</span></p>' );

                  var upselling_product = $('<div class="single_upsell_product"></div>');


                  image.append( cartButton );
                  cartButton.on('click', upsellingadd );
                  upselling_product.append( image );
                  upselling_product.append( subtext );

                  $('.upselling-product-list').append( upselling_product );    

                }
            });
             
             if ( $('.upselling-product-list').children().length === 0 ){
               $('#sidebar-cart-upselling').remove()
             }

           });

         });
      
    } else $('#sidebar-cart-upselling').remove();
  
  } else $('#sidebar-cart-upselling').remove();
  

  if ( $('#sidebar-cart').length == 1 ){
    
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type == "attributes") {
          if ( mutation.attributeName == 'aria-hidden' ){
              upsellSlide();
          }
        }
      });
    });

    observer.observe($('#sidebar-cart')[0], { attributes: true });
    $('#upsalling-footer [name=checkout]').on('click', function(){
      $('.Cart .Cart__Checkout').trigger('click');
    });
    
  }
  
  $('.upselling-addToCart').on('click', upsellingadd );
  
  
  
  
  $('body').on( 'change', '.giftcheckbox', function() {
     if($(this).is(":checked")) {
       $(this).siblings(".colorselect").fadeIn();
       var fillattrval = $(this).siblings(".colorselect").children(".fillattrval").html();
       $(this).siblings(".colorselect").children(".giftwrapattr").attr("name",fillattrval);
     }
     else{
       $(this).siblings(".colorselect").children(".giftwrapattr").attr("name","");
       $(this).siblings(".colorselect").fadeOut();
     }
        
    });
  
  $("body").on('click','.colorselect > img', function(){
    if($(this).hasClass("selected")){}else{
      var getvalue = $(this).attr("data-label");
      $(this).siblings(".giftwrapattr").val(getvalue);
      $(this).siblings(".selected").removeClass("selected");
      $(this).addClass("selected");
    }
  });
  
  
  
if ( $('.product-form-sticky').length ){
  
  var stickyCart = $('.product-form-sticky .product-form-row');
  if ( stickyCart.length == 0 ){
    stickyCart = $('.product-form-sticky .product-form-row-one');
  }
  
  // adding scroll event
  window.addEventListener('scroll', function(){

    var posTemplate = $('#shopify-section-product-template').position().top;
    var heightTemplate = $('#shopify-section-product-template').height();    
    var pos = (document.body.getBoundingClientRect()).top*-1;
    
    
    if ( pos > ( heightTemplate+posTemplate ) ){
      if ( !stickyCart.is(':hidden') ) stickyCart.fadeOut();
    } else {
      if ( stickyCart.is(':hidden') ) stickyCart.fadeIn();;
      
    }

  });
}

if ( $('.sticky-cart-button' ).length > 0 ){
  
  $('.sticky-cart-button').on('click',function(){
    $('Form .Cart__Checkout').trigger('click');
  });
  
  
  
  // adding scroll event
  window.addEventListener('scroll', function(){
	
    
    var posTemplate = $('#shopify-section-cart-template').position().top;
    var heightTemplate = $('#shopify-section-cart-template').height();    
    var pos = (document.body.getBoundingClientRect()).top*-1;
    
    
     if ( pos > ( heightTemplate+posTemplate ) ){
      $('.sticky-cart-button').fadeOut();;
    } else {
      $('.sticky-cart-button').fadeIn();
    }

  });
  
}

 
  
  
  
  function upsellingadd(){
    
    var currentProduct = $('.ProductForm__Variants [name=id]').val();
    
    var button = $(this);
    // aktuellen warenkorb holen!
    jQuery.getJSON('/cart.js', function( cart ){
      
      var vals = {
        quantity: 1,
        id: button.attr('data-product-id')
      }


      /*
      wenn es sich um ein geschenk handelt dann checken

      befindet sich schon ein geschenk im warenkorb? wenn ja dann nichts machen
      wenn kein produkt im warenkorb ist das dieses geschenk erlaubt dann ebenfalls beenden

      */
      if ( button.hasClass( 'single_gift_product_image' ) ){

		// checken ob schon ein geschenk drin ist - wenn ja dann löschen und ersetzen
        
        // wenn das Produkt noch nicht drin ist - einfach reinschmeissen
        
        /*allowed_gifts = {};*/
        var product_in_cart = false;
        
        // nur ein Geschenk pro Warenkorb
        
        for ( var i = 0; i < cart['items'].length; i++ ){
          
        	var item = cart['items'][i];
          	
          	// wenn wir keine properties für das item haben dann weiter
          	if ( item['properties'] == null ){
              	
            	continue;
            }
          
          	// wenn wir schon ein geschenk im warenkorb haben rausschmeissen
          	if ( item['properties']['_is_gift'] != null ){            	
              
                var ob = {
                  'id' : item['key'],
                  'quantity' : 0
                };              	
                
                $.ajax({
                  type: 'POST',
                  url: '/cart/change.js',
                  data: ob,
                  async:false
                });
              
          	}
          
          	if ( item['id'] == currentProduct ) product_in_cart = true;
          
        }        
        
        // wir haben alle geschenke rausgeschmissen und ggf. haben wir das Produkt schon im Warenkorb gefunden wenn nicht hinzufügen
        if ( !product_in_cart ){
          
          props = {}
          if ( $('.giftlist_add').length > 0 ){
			props['_can_have_gift'] = $('.giftlist_add').val();
		  }
          
          var ob = {
            'id' : currentProduct,
            'quantity' : 1,
            'properties' : props
          };    
          
          

          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: ob,
            async:false
          });
        }
        
        vals['properties'] = {};
        vals['properties']['_is_gift'] = 1;

        
        
       
        
        $('.gift-message').hide();
        $('.gift-message-inner').html('');
        
        var ms = button.parent().find('.gift-message');        
        ms.show();
        var msinner = ms.find( '.gift-message-inner');
        msinner.html( '&#10003;' );
        msinner.css({
          'color': 'green',
          'font-size': '5rem'
        });
        
         // geschenk hinzufüen
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: vals,
          async:false
        });
        
        refreshCart();
        closeGifts();    
        showCart();    
       
        return;
        
        
      }

      var cartAjaxUrl = '/cart/add.js';
      
      //Make AJAX Call
      jQuery.post(
        cartAjaxUrl, vals      
      ).always(function() {	
        refreshCart();
      });

     });
    
    
    
    
    
  };

 

});


  
  

/* prestige fix: https://support.maestrooo.com/article/209-fixing-product-image-list-being-hard-to-scroll-on-ios13 */
(function() {
    var touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  })();
/* end of prestige fix*/
